/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// pages
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname_container';
// material
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedname/embedname_styles';



/* ========== ~~~~~~~~~~ EMBED NAME : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EmbedName = (props) => {
	const handleClick = (e) => {
		props.displayModal(true, <EditEmbedName createEmbed={false} updateEmbed={props.handleSaveEmbed} />)
	};
	return (
		<div className={`embedname ${props.classes.embedname}`} onClick={handleClick}>
			<span className={'name'}>{props.embedName ? props.embedName : 'Embed Name'}</span>
			/
			<span className={'site'}>{props.siteURL ? props.siteURL : 'http://site.com'}</span>
			<Icon name={`edit`} />
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedName);
